import React, { useContext } from 'react';
import { ProductPageContext } from './ProductPageContext';
import { PageProductSuggestions } from './PageProductSuggestions';
import { getHash } from './ProductDetailShared';

// "Produk Lainnya" — a seeded shuffle of the catalog, excluding the product
// being viewed. Wraps the existing suggestions slider so the two surfaces
// (product page and elsewhere) can't drift apart.

export interface BlockProductRelatedData {
  heading?: string;
  marginTop?: string;
  marginBottom?: string;
  // Lifts the block out of the narrow desktop rail. Read by ProductPageBody.
  fullWidth?: boolean;
}

export default function BlockProductRelated({ content }: { content: BlockProductRelatedData }) {
  const page = useContext(ProductPageContext);
  if (!page) return null;

  // Seed rotates roughly every ~17 minutes (the date string is truncated to
  // the tens-of-minutes digit), so a returning shopper sees a fresh set
  // while a single page view stays stable. Inherited from the old page.
  const seed = getHash(page.productId + new Date().toISOString().substring(0, 15));

  return (
    <PageProductSuggestions
      seedNumber={seed}
      excludedProductId={page.productId}
      // PageProductSuggestions' own fallback is fareast clothing copy
      // ("Cari Baju Buat Acara Lain") — wrong on a store selling anything
      // else, so the block supplies a neutral default of its own.
      titleText={content?.heading || 'Produk Lainnya'}
      marginTop={content?.marginTop}
      marginBottom={content?.marginBottom} />
  );
}
